export default {
    getUploadTokenUrl: '/v1/common/uploadtoken',
    mockLogin: '/v1/user/smslogin',
    actAdd: '/v1/activityitem/add ',
    getList: '/v1/activity/votinglist',
    vote: '/v1/activity/vote'
};
